import * as http from './http';
import ApiService from './service';
import { ExamTypes, MockTestInstructions } from '../models/mocktest';
const serviceEndpoint = 'curriculum/v1/mocktest-cms/page';
const questionsServiceEndpoint = 'curriculum/v1/mocktest-quiz/examType';
const mocktestQuizBaseEndpoint = 'curriculum/v1/mocktest-quiz';

export default class MockTestService extends ApiService {
  public async loadInstructions() {
    const url = `${this.apiDomain}/${serviceEndpoint}/instructions`;
    return http.get(url, this.token);
  }

  public async loadInstructionsForTrainingCenter() {
    const url = `${this.apiDomain}/curriculum/v1/training-center/page/instructions`;
    return http.get(url, this.token);
  }

  public async loadQuestions(examType: ExamTypes) {
    const url = `${this.apiDomain}/${questionsServiceEndpoint}/${examType}`;
    return http.get(url, this.token);
  }

  public async loadQuestionsForTrainingCenter(params?: {
    _start?: number;
    _end?: number;
    _filters?: Record<string, unknown>;
    _sort?: string;
    _order?: 'ASC' | 'DESC';
    _getcount?: boolean;
  }) {
    const defaultParams = {
      _start: 0,
      _end: 20,
      _filters: JSON.stringify({ enabledForTrainingCenter: true }),
      _sort: 'createdAt',
      _order: 'DESC',
      _getcount: false,
    };
    const merged = { ...defaultParams, ...params };
    const filtersStr =
      typeof merged._filters === 'string'
        ? merged._filters
        : JSON.stringify(merged._filters || { enabledForTrainingCenter: true });
    const query = new URLSearchParams({
      _start: String(merged._start),
      _end: String(merged._end),
      _filters: filtersStr,
      _sort: merged._sort!,
      _order: merged._order!,
      _getcount: String(merged._getcount),
    });
    const url = `${
      this.apiDomain
    }/${mocktestQuizBaseEndpoint}?${query.toString()}`;
    return http.get(url, this.token);
  }

  public async submitAnswers(payload: any) {
    const url = `${this.apiDomain}/curriculum/v1/mocktest-reports/save-mocktest-result`;
    return http.post(url, payload, this.token);
  }

  public async getSubmitAnswerData(submitId: string) {
    const url = `${this.apiDomain}/curriculum/v1/mocktest-reports/${submitId}`;
    return http.get(url, this.token);
  }
}
